import { IData } from 'interface/common';
import { IMediaTag } from 'interface/media-tags';
import { IPageOptions } from 'interface/pagination';

export enum MediaType {
  IMAGE = 'Image',
  VIDEO = 'Video',
  YOUTUBE = 'Youtube',
}

export enum MediaPurpose {
  RENTAL_PROPERTY = 'RentalProperty',
  CONTENT = 'Content',
}

export interface IMedia extends IData {
  mediaPurpose: MediaPurpose;
  mediaType: MediaType;
  source: string;
  name: string;
  description: string;
  public: boolean;
  likes: number;
  liked: boolean;
  views: number;
  tags: IMediaTag[];
}

export enum MediaOrderBy {
  ID = 'id',
  NAME = 'name',
  DESCRIPTION = 'description',
  LIKES = 'likes',
  VIEWS = 'views',
  UPDATED_AT = 'updatedAt',
}

export interface IMediaPageOptions extends IPageOptions {
  orderBy?: MediaOrderBy;
}

export interface IMediaQuery extends IMediaPageOptions {
  mediaPurposes?: MediaPurpose[];
  mediaTypes?: MediaType[];
  name?: string;
  description?: string;
}
